/** @jsx h */
import { h, Component } from 'preact'
import { useState } from 'preact/hooks'

import JourneyOrganization from './Organization'
import JourneyShare from './Share'
import Feedback from '../feedback/Feedback'
import BrandingWordmarkFlag from '../../../../assets/images/svgs/branding-wordmark-flag.svg'
import BrandingWordmarkLogo from '../../../../assets/images/svgs/branding-wordmark-logos.svg'
import t from '../../../utils/translate'
import { pageViewEvent } from '../../utils/analytics'

export default class JourneyCreditsView extends Component {
  componentDidMount () {
    pageViewEvent(`${this.props.href}/credits`)
  }

  handleClick = () => {
    this.props.populateDrawer(this.props.poweredBy)
  }

  render () {
    const {
      id,
      numberOfStages,
      href,
      title,
      organization,
      exitLink,
      exitButtonLabel,
      shareImage,
      socialShareDisabled
    } = this.props

    const [showLogo, setShowLogo] = useState(false)

    return (
      <article id={`${id}-${numberOfStages + 1}`} class='Journey'>
        <div class='Journey-content Journey-content--credits noselect'>
          <div class='u-marginTopAuto' />
          {!socialShareDisabled && (
            <div class='u-marginBottom16'>
              <JourneyShare
                href={href}
                title={title}
                organization={organization}
                shareImage={shareImage}
              />
              {exitLink.length > 0 && (
                <JourneyOrganization
                  {...organization}
                  orgLocation={organization.location.displayName}
                  exitLink={exitLink}
                  exitButtonLabel={exitButtonLabel}
                  socialShareDisabled={socialShareDisabled}
                />
              )}
            </div>
          )}
          <Feedback
            dark
            context='Story'
            organizationName={organization.name}
            analyticsName={title}
          />
          <div
            class='Journey-bottom Journey-bottom--credits'
            onMouseOver={() => { setShowLogo(true) }}
            onMouseLeave={() => { setShowLogo(false) }}
          >
            {!showLogo
              ? (
                <span>
                  <BrandingWordmarkFlag onClick={this.handleClick} className='Journey-branding' />
                </span>)
              : (
                <span>
                  <BrandingWordmarkLogo onClick={this.handleClick} className='Journey-branding Journey-branding--click' />
                </span>
                )}
          </div>
        </div>
      </article>
    )
  }
}

JourneyCreditsView.defaultProps = {
  exitButtonLabel: t('journeys.js.credits.exit_button_label')
}
